import {
  type AppLocale,
  type MessageTree,
  normalizeLocale,
} from "@airange/shared/i18n-airange-admin-runtime";
import routeConfig from "../app/routes";

const menuMessageKeyAliases: Record<string, string> = {
  dashboard: "platform.admin.menu.dashboard",
  portalManagement: "platform.admin.menu.portalManagement",
  portalAppearance: "platform.admin.menu.portalAppearance",
  portalUiSemantics: "platform.admin.menu.portalUiSemantics",
  portalGroups: "platform.admin.menu.portalGroups",
  portalEntries: "platform.admin.menu.portalEntries",
  portalAccess: "platform.admin.menu.portalAccess",
  portalSecurity: "platform.admin.menu.portalSecurity",
  identity: "platform.admin.identity.title",
  identityApplications: "platform.admin.menu.identityApplications",
  identityTenants: "platform.admin.menu.identityTenants",
  identityOrganizations: "platform.admin.menu.identityOrganizations",
  identityUsers: "platform.admin.menu.identityUsers",
  identityUserCustomFields: "platform.admin.menu.identityUserCustomFields",
  identityRoles: "platform.admin.menu.identityRoles",
  identityPermissions: "platform.admin.menu.identityPermissions",
  identityEvents: "platform.admin.menu.identityEvents",
  identityLoginRecords: "platform.admin.menu.identityLoginRecords",
  assetsCenter: "platform.admin.assets.title",
  assetsDashboard: "platform.admin.menu.dashboard",
  assetsGovernance: "platform.admin.assets.menu.governance",
  assetsObjectSpaces: "platform.admin.assets.menu.objectSpaces",
  assetsReferences: "platform.admin.assets.menu.references",
  assetsPublicBranding: "platform.admin.assets.values.publicBranding",
  environmentCenter: "platform.environment.title",
  environmentKvm: "platform.environment.menu.kvm",
  environmentContainer: "platform.environment.menu.container",
  environmentDynamips: "platform.environment.menu.dynamips",
  environmentDynamipsIosImages: "platform.environment.menu.dynamipsIosImages",
  environmentDynamipsSpecs: "platform.environment.menu.dynamipsSpecs",
  environmentFirecracker: "platform.environment.menu.firecracker",
  environmentMicrovmSpecs: "platform.environment.menu.microvmSpecs",
  environmentFirecrackerKernels: "platform.environment.menu.firecrackerKernels",
  environmentFirecrackerRootfsImages: "platform.environment.menu.firecrackerRootfsImages",
  environmentFirecrackerApplicationImages: "platform.environment.menu.firecrackerApplicationImages",
  environmentSimulator: "platform.environment.menu.simulator",
  environmentSimulatorModels: "platform.environment.menu.simulatorModels",
  environmentTopology: "platform.environment.menu.topology",
  environmentDashboard: "platform.admin.menu.dashboard",
  environmentBaseImages: "platform.environment.menu.baseImages",
  environmentImageArtifactTasks: "platform.environment.menu.imageArtifactTasks",
  environmentCloudInitProfiles: "platform.environment.menu.cloudInitProfiles",
  environmentContainerImages: "platform.environment.menu.containerImages",
  environmentImagePortServiceProtocols: "platform.environment.menu.imagePortServiceProtocols",
  environmentPhysicalDevices: "platform.environment.menu.physicalDevices",
  environmentCustomImages: "platform.environment.menu.customImages",
  environmentContainerSpecs: "platform.environment.menu.containerSpecs",
  environmentVmSpecs: "platform.environment.menu.vmSpecs",
  environmentApplicationImages: "platform.environment.menu.applicationImages",
  environmentSystemCoreImages: "platform.environment.menu.systemCoreImages",
  environmentTopologyDefaultImagePolicy: "platform.environment.menu.topologyDefaultImagePolicy",
  environmentTopologyTemplates: "platform.environment.menu.topologyTemplates",
  environmentTopologyVersions: "platform.environment.menu.topologyVersions",
  environmentHarbor: "platform.environment.menu.harbor",
  executionCenter: "platform.executionCenter.title",
  executionDashboard: "platform.admin.menu.dashboard",
  executionScheduling: "platform.executionCenter.menu.scheduling",
  executionInstances: "platform.executionCenter.menu.instances",
  executionProviders: "platform.executionCenter.menu.providers",
  executionTargets: "platform.executionCenter.menu.targets",
  executionNodes: "platform.executionCenter.menu.nodes",
  executionDocker: "platform.executionCenter.menu.docker",
  executionVm: "platform.executionCenter.menu.vm",
  executionEvents: "platform.executionCenter.menu.events",
  executionRawEvents: "platform.executionCenter.menu.rawEvents",
  executionNodeHeartbeats: "platform.executionCenter.menu.nodeHeartbeats",
  executionErrorCodes: "platform.executionCenter.menu.errorCodes",
  taskCenter: "platform.taskCenter.title",
  taskCenterDashboard: "platform.taskCenter.menu.dashboard",
  taskCenterTasks: "platform.taskCenter.menu.tasks",
  taskCenterEvents: "platform.taskCenter.menu.events",
  taskCenterErrorCodes: "platform.taskCenter.menu.errorCodes",
  instanceCenter: "platform.instanceCenter.title",
  instanceDashboard: "platform.admin.menu.dashboard",
  instanceInstances: "platform.instanceCenter.menu.vmInstances",
  instanceVmInstances: "platform.instanceCenter.menu.vmInstances",
  instanceContainerInstances: "platform.instanceCenter.menu.containerInstances",
  instanceTopologyInstances: "platform.instanceCenter.menu.topologyInstances",
  instanceRemoteSessions: "platform.instanceCenter.menu.remoteSessions",
  instanceUserVirtualizationQuotas: "platform.instanceCenter.menu.userVirtualizationQuotas",
  instanceUserVirtualizationQuotaUsers: "platform.instanceCenter.virtualizationQuotas.menu.users",
  instanceUserVirtualizationQuotaPolicy: "platform.instanceCenter.virtualizationQuotas.menu.policy",
  instanceUserVirtualizationQuotaProfiles:
    "platform.instanceCenter.virtualizationQuotas.menu.profiles",
  instanceUserVirtualizationQuotaLeases: "platform.instanceCenter.virtualizationQuotas.menu.leases",
  orchestratorCenter: "platform.orchestratorCenter.title",
  orchestratorDashboard: "platform.admin.menu.dashboard",
  orchestratorCapabilityMap: "platform.orchestratorCenter.menu.capabilityMap",
  orchestratorRequests: "platform.orchestratorCenter.menu.requests",
  orchestratorRecycles: "platform.orchestratorCenter.menu.recycles",
  orchestratorActions: "platform.orchestratorCenter.menu.actions",
  intelligenceCenter: "platform.intelligenceCenter.title",
  intelligenceCenterDashboard: "platform.intelligenceCenter.menu.dashboard",
  intelligenceModelConnections: "platform.intelligenceCenter.menu.modelConnections",
  intelligenceProviderConfigs: "platform.intelligenceCenter.menu.providerConfigs",
  intelligenceTaskRuns: "platform.intelligenceCenter.menu.taskRuns",
  intelligenceAuditLogs: "platform.intelligenceCenter.menu.auditLogs",
  opsCenter: "platform.opsCenter.title",
  opsCenterDashboard: "platform.opsCenter.menu.dashboard",
  opsCenterModules: "platform.opsCenter.menu.modules",
  opsCenterServiceEndpoints: "platform.opsCenter.menu.serviceEndpoints",
  opsCenterLogs: "platform.opsCenter.menu.logs",
  opsCenterMqObservability: "platform.opsCenter.menu.mqObservability",
  opsCenterRedisObservability: "platform.opsCenter.menu.redisObservability",
  opsCenterWorkerObservability: "platform.opsCenter.menu.workerObservability",
  opsCenterEventDeliveryObservability: "platform.opsCenter.menu.eventDeliveryObservability",
  opsCenterExecutionChainObservability: "platform.opsCenter.menu.executionChainObservability",
  opsCenterContractHealthObservability: "platform.opsCenter.menu.contractHealthObservability",
  opsCenterAuthHealthObservability: "platform.opsCenter.menu.authHealthObservability",
  capabilityGraph: "platform.capabilityGraph.title",
  capabilityGraphDashboard: "platform.admin.menu.dashboard",
  capabilityGraphCapabilities: "platform.capabilityGraph.menu.capabilities",
  capabilityGraphCapabilityDetail: "platform.capabilityGraph.menu.capabilityDetail",
  capabilityGraphKsaCategories: "platform.capabilityGraph.menu.ksaCategories",
  capabilityGraphKsaKnowledgeCategories:
    "platform.capabilityGraph.ksaCategories.groups.knowledge.title",
  capabilityGraphKsaSkillCategories: "platform.capabilityGraph.ksaCategories.groups.skill.title",
  capabilityGraphKsaAbilityCategories:
    "platform.capabilityGraph.ksaCategories.groups.ability.title",
  capabilityGraphGraph: "platform.capabilityGraph.menu.graph",
  tacticsTechniquesHub: "platform.tacticsTechniquesHub.title",
  tacticsTechniquesDashboard: "platform.admin.menu.dashboard",
  tacticsTechniquesFrameworks: "platform.tacticsTechniquesHub.menu.frameworks",
  tacticsTechniquesBindingPlayground: "platform.tacticsTechniquesHub.menu.bindingPlayground",
  tacticsTechniquesApiReference: "platform.tacticsTechniquesHub.menu.apiReference",
  tacticsTechniquesFrameworkMatrix: "platform.tacticsTechniquesHub.menu.matrix",
  tacticsTechniquesFrameworkTree: "platform.tacticsTechniquesHub.menu.tree",
  tacticsTechniquesFrameworkVersionMappings: "platform.tacticsTechniquesHub.menu.versionMappings",
  vulnerabilityLibrary: "platform.vulnerabilityLibrary.title",
  vulnerabilityLibraryDashboard: "platform.admin.menu.dashboard",
  vulnerabilityLibraryVulnerabilities: "platform.vulnerabilityLibrary.menu.vulnerabilities",
  vulnerabilityLibraryVulnerabilityDetail:
    "platform.vulnerabilityLibrary.vulnerabilities.detailTitle",
  vulnerabilityLibrarySourceRecords: "platform.vulnerabilityLibrary.menu.sourceRecords",
  vulnerabilityLibrarySourceRecordDetail: "platform.vulnerabilityLibrary.sourceRecords.detailTitle",
  vulnerabilityLibrarySources: "platform.vulnerabilityLibrary.menu.sources",
  vulnerabilityLibraryImportJobs: "platform.vulnerabilityLibrary.menu.importJobs",
  businessReferenceCenter: "platform.businessReferenceCenter.title",
  businessReferenceCenterDashboard: "platform.admin.menu.dashboard",
  businessReferenceResourceTypes: "platform.businessReferenceCenter.menu.resourceTypes",
  businessReferenceRelationTypes: "platform.businessReferenceCenter.menu.relationTypes",
  businessReferenceReferences: "platform.businessReferenceCenter.menu.references",
  toolsLibrary: "platform.toolsLibrary.title",
  toolsLibraryTools: "platform.toolsLibrary.menu.tools",
  toolsLibraryCategories: "platform.toolsLibrary.menu.categories",
  trafficLibrary: "platform.trafficLibrary.title",
  trafficLibraryPacketFiles: "platform.trafficLibrary.menu.packetFiles",
  trafficLibraryCategories: "platform.trafficLibrary.menu.categories",
  knowledgeLibrary: "platform.knowledgeLibrary.title",
  knowledgeLibraryItems: "platform.knowledgeLibrary.menu.items",
  knowledgeLibraryCategories: "platform.knowledgeLibrary.menu.categories",
  centers: "platform.admin.menu.applications",
};

type RouteLocaleNode = {
  name?: string;
  routes?: RouteLocaleNode[];
};

function buildNestedMenuMessageKeyAliases(
  routes: readonly RouteLocaleNode[],
  parentNames: string[] = [],
): Record<string, string> {
  return routes.reduce<Record<string, string>>((result, route) => {
    const nextParentNames = route.name ? [...parentNames, route.name] : parentNames;
    if (route.name) {
      const sourceKey = menuMessageKeyAliases[route.name];
      if (sourceKey) {
        result[`menu.${nextParentNames.join(".")}`] = sourceKey;
      }
    }
    if (route.routes?.length) {
      Object.assign(result, buildNestedMenuMessageKeyAliases(route.routes, nextParentNames));
    }
    return result;
  }, {});
}

const deterministicNestedMenuMessageKeyAliases: Record<string, string> = {
  "menu.environmentCenter.environmentHarbor": "platform.environment.menu.harbor",
};

export const menuMessageKeys = {
  ...Object.fromEntries(
    Object.entries(menuMessageKeyAliases).map(([menuKey, sourceKey]) => [
      `menu.${menuKey}`,
      sourceKey,
    ]),
  ),
  ...buildNestedMenuMessageKeyAliases(routeConfig as RouteLocaleNode[]),
  ...deterministicNestedMenuMessageKeyAliases,
} as const;

export function flattenMessageTree(tree: MessageTree, prefix = ""): Record<string, string> {
  return Object.entries(tree).reduce<Record<string, string>>((result, [key, value]) => {
    const nextPrefix = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      result[nextPrefix] = value;
      return result;
    }
    return {
      ...result,
      ...flattenMessageTree(value, nextPrefix),
    };
  }, {});
}

async function loadLocaleCatalog(locale: AppLocale): Promise<MessageTree> {
  switch (locale) {
    case "en":
      return (await import("@airange/shared/i18n-airange-admin-en")).localeCatalog;
    case "ja":
      return (await import("@airange/shared/i18n-airange-admin-ja")).localeCatalog;
    case "zh-CN":
      return (await import("@airange/shared/i18n-airange-admin-zh-cn")).localeCatalog;
  }
}

export async function loadUmiLocaleMessages(locale: AppLocale) {
  const flatMessages = flattenMessageTree(await loadLocaleCatalog(normalizeLocale(locale)));
  const menuMessages = Object.fromEntries(
    Object.entries(menuMessageKeys).map(([menuKey, sourceKey]) => [
      menuKey,
      flatMessages[sourceKey] ?? sourceKey,
    ]),
  );
  return {
    ...flatMessages,
    ...menuMessages,
  };
}
